import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Job } from '../../models/job.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  apiUrl = environment.jazzApiUrl;

  constructor(private http: HttpClient) { }

  getJobs(){
    return this.http.get<Job>(this.apiUrl);
  }
}
